import axiosInstance from './';

import Storage from '../helpers/storage';

export default class {
  constructor() {
    this.instance = axiosInstance();
  }

  get = () =>
    this.instance({
      url: `/categories?merchantId=${Storage.getLocalStorageMerchant().idUnity}`,
      method: 'GET',
    });

  post = data =>
    this.instance({
      url: '/categories',
      method: 'POST',
      data: { ...data, merchantId: Storage.getLocalStorageMerchant().idUnity },
    });

  put = (id, data) =>
    this.instance({
      url: `/categories/patch/${id}`,
      method: 'PUT',
      data,
    });

  sortOrder = category =>
    this.instance({
      url: `/categories/patch/${category.id}/sortOrder`,
      method: 'PUT',
      data: {
        sortOrder: category.sortOrder,
        merchantId: Storage.getLocalStorageMerchant().idUnity,
      },
    });
}



// WEBPACK FOOTER //
// ./src/services/Categories.js